<h6 class="card-title m-0 px-2 d-flex w-100">
  <div class="d-flex justify-content-between w-100 pt-1">
    <mat-icon>{{ icon }}</mat-icon>
    <span class="pt-1">{{ title }}</span>
    @if (hintText) {
      <span class="ms-auto text-end pt-1">{{ hintText }}</span>
    }
  </div>
  <div class="toggler">
    <a href="#toggleCollapsed" class="toggle" (click)="onToggleCollapseClick($event)">
      @if (collapsed) {
        <mat-icon>chevron_right</mat-icon>
      }
      @if (!collapsed) {
        <mat-icon>expand_more</mat-icon>
      }
    </a>
  </div>
</h6>
